'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardSection from 'UIComponents/card/UICardSection';
import { STAR_RATING_FILLED } from '../../constants/reviews/RatingTypes';
import { MINIMUM_REVIEWS_FOR_DISPLAY } from '../../constants/reviews/ReviewsListQueries';
import Rating from '../reviews/Rating';
import AbstractCard from './AbstractCard';
import AppCardInstalls from './AppCardInstalls';
import Footer from './Footer';

const AppCard = props => {
  const {
    companyName,
    hubInstalls,
    iconUrl,
    installed,
    installsCount,
    name,
    reviewSummary,
    showIsNewApp,
    tagline
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["companyName", "hubInstalls", "iconUrl", "installed", "installsCount", "name", "reviewSummary", "showIsNewApp", "tagline"]);

  const renderedCompanyName = useMemo(() => {
    if (companyName) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystemMarketplaceCore.cards.appCard.companyName",
        options: {
          companyName
        }
      });
    }

    return null;
  }, [companyName]);
  const renderBody = useCallback(() => {
    if (!reviewSummary || reviewSummary.reviewCount < MINIMUM_REVIEWS_FOR_DISPLAY) {
      return null;
    }

    return /*#__PURE__*/_jsx(UICardSection, {
      className: "p-bottom-0 p-top-3",
      children: /*#__PURE__*/_jsx(Rating, {
        rating: reviewSummary.overallRating,
        label: reviewSummary.reviewCount,
        use: "card",
        type: STAR_RATING_FILLED
      })
    });
  }, [reviewSummary]);
  const renderFooter = useCallback(() => {
    return /*#__PURE__*/_jsx(Footer, {
      children: /*#__PURE__*/_jsx(AppCardInstalls, {
        installed: installed,
        installsCount: installsCount != null ? installsCount : hubInstalls,
        showIsNewApp: showIsNewApp
      })
    });
  }, [hubInstalls, installed, installsCount, showIsNewApp]);
  return /*#__PURE__*/_jsx(AbstractCard, Object.assign({}, rest, {
    bodyComponent: renderBody,
    footerComponent: renderFooter,
    iconUrl: iconUrl,
    subtitle: tagline,
    title: name,
    titleHelpText: renderedCompanyName
  }));
};

AppCard.propTypes = {
  companyName: PropTypes.string,
  hubInstalls: PropTypes.number,
  iconUrl: PropTypes.string.isRequired,
  installed: PropTypes.bool,
  installsCount: PropTypes.number,
  name: PropTypes.string.isRequired,
  reviewSummary: PropTypes.shape({
    overallRating: PropTypes.number.isRequired,
    reviewCount: PropTypes.number.isRequired
  }),
  showIsNewApp: PropTypes.bool,
  tagline: PropTypes.string
};
AppCard.defaultProps = {
  installed: false,
  showIsNewApp: false,
  tagline: ''
};
export default AppCard;